/**
 * View component for /sentiment-questions/new
 *
 * Creates a new sentimentQuestion from a copy of the defaultItem in the sentimentQuestion reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as sentimentQuestionActions from '../sentimentQuestionActions.js';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import question components
import SentimentQuestionForm from '../components/SentimentQuestionForm.js.jsx';
import SentimentQuestionLayout from '../components/SentimentQuestionLayout.js.jsx';

class CreateSentimentQuestion extends Base {
  constructor(props) {
    super(props);
    this.state = {
      sentimentQuestion: _.cloneDeep(this.props.defaultSentimentQuestion)
      // NOTE: We don't want to actually change the store's defaultItem, just use a copy
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  _handleFormChange(e) {
    /**
     * This let's us change arbitrarily nested objects with one pass
     */
    let newSentimentQuestionState = _.update( this.state.sentimentQuestion, e.target.name, function() {
      return e.target.value;
    });
    this.setState({sentimentQuestion :newSentimentQuestionState});
  }


  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(sentimentQuestionActions.sendCreateSentimentQuestion(this.state.sentimentQuestion)).then((action) => {
      if(action.success) {
        dispatch(sentimentQuestionActions.invalidateList());
        history.push(`/admin/sentiment-questions/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert("ERROR - Check logs");
      }
    });
  }

  render() {
    const { sentimentQuestion } = this.state;
    const isEmpty = !sentimentQuestion;
    return (
      <div>
        <div className="flex">
          <section className="section">
            {isEmpty ?
              <h2> Loading...</h2>
              :
              <SentimentQuestionForm
                sentimentQuestion={sentimentQuestion}
                cancelLink="/admin/sentiment-questions"
                formTitle="Create Sentiment Question"
                formType="create"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
                />
            }
          </section>
        </div>
      </div>
    )
  }
}

CreateSentimentQuestion.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    defaultSentimentQuestion: store.sentimentQuestion.defaultItem
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(CreateSentimentQuestion)
);



// WEBPACK FOOTER //
// modules/sentimentQuestion/views/CreateSentimentQuestion.js.jsx